













































import {AccessLand} from '@/components/estimates/common/controls/values';
import {TranslateResult} from 'vue-i18n';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class AccessLandControl extends Vue {

    private get newValue(): AccessLand | null {
        if (this.prefixNumber === null || this.landType === '') {
            return null;
        }

        return {
            prefixNumber: this.prefixNumber,
            suffixNumber: this.suffixNumber,
            landType: this.landType,
            description: this.description,
        };
    }

    private get error(): TranslateResult | null {
        return this.validate
            ? this.getError()
            : null;
    }
    @Prop({type: Array, required: true})
    public readonly landTypes: string[];

    @Prop({required: true})
    public readonly value: AccessLand | null;

    @Prop({type: Boolean, required: true})
    public readonly validate: boolean;

    public prefixNumber: number | null = null;
    public suffixNumber: number | null = null;
    public landType: string = '';
    public description: string | null = null;

    public removeLandAccess(value: AccessLand | null): void {
        this.$emit('remove');
    }

    protected mounted(): void {
        if (this.value !== null) {
            this.prefixNumber = this.value.prefixNumber;
            this.suffixNumber = this.value.suffixNumber;
            this.landType = this.value.landType;
            this.description = this.value.description;
        }
    }

    private getError(): TranslateResult | null {
        if (this.prefixNumber === null) {
            return this.$t('form.errors.accessLands.prefixNumberNotFilled');
        }

        if (this.landType === '') {
            return this.$t('form.errors.accessLands.landTypeNotSelected');
        }

        return null;
    }

    @Watch('prefixNumber')
    @Watch('suffixNumber')
    @Watch('landType')
    @Watch('description')
    private valueChanged(): void {
        this.$emit('input', this.newValue);
    }
}
